<template>
  <base-error :error="error" type="Forbidden"></base-error>
</template>

<script>
import base_error from "./base_error"

export default {
  components: {
    "base-error": base_error,
  },
  data: function () {
    return {
      dialog: false,
    }
  },
  props: { error: Object },
}
</script>
